"use strict";

module.exports = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
		return false;
	}
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/object/keys/is-implemented.js
// module id = 682
// module chunks = 0